<template>
  <div class="text-input">
    <template v-if="!readOnly">
      <input v-if="valueType==='string'" v-model="internalValue"/>
      <text-with-units v-else v-model="internalValue" :unit="view.units" :min="minVal" :max="maxVal" />
    </template>
    <template v-else>
      <span class="value">{{internalValue?internalValue:'-'}}</span>
    </template>
  </div>
</template>

<script>
import inputMixin from '@/mixins/inputMixin'
import TextWithUnits from '@/components/inputs/TextWithUnits'
export default {
  name: 'TextInput',
  mixins: [inputMixin],
  components: {TextWithUnits}
}
</script>

<style lang="stylus" scoped>
.text-input
  display: flex;
  // input
  //   min-width 300px
</style>